import React from 'react';
import { Badge, Form } from 'react-bootstrap';

import { useTranslation } from '../../../common/hooks/useTranslation';
import { TimelineStepEnum } from '../../../common/pokCore/validation/enums';

interface NoMediaplanSubItemProps {
  itemType: TimelineStepEnum;
  itemCompleted: boolean;
  noMediaplanStep?: {
    stepDefinitionId: string;
    text: string;
    completed: boolean;
  };
  onChange?: (id: string, completed: boolean) => void;
}

export const NoMediaplanSubItem: React.FC<NoMediaplanSubItemProps> = ({
  itemType,
  itemCompleted,
  noMediaplanStep,
  onChange,
}) => {
  const { t, tk } = useTranslation('projectLng');

  if (
    itemType !== TimelineStepEnum.AtLeastOneProfilePerMonth ||
    !noMediaplanStep ||
    (itemCompleted && !noMediaplanStep.completed)
  ) {
    return null;
  }

  return (
    <div className="ms-4 mt-2 ps-3 border-start border-secondary border-2">
      <Form.Check
        type="checkbox"
        id={`no-mediaplan-${noMediaplanStep.stepDefinitionId}`}
        className="mb-0 text-muted"
        checked={noMediaplanStep.completed}
        label={
          <>
            <small className="text-muted">
              <em>{noMediaplanStep.text}</em>
            </small>
            <Badge className="ms-2" bg="info" pill>
              {t(tk.timeLine.manual)}
            </Badge>
          </>
        }
        onChange={e =>
          onChange?.(noMediaplanStep.stepDefinitionId, e.target.checked)
        }
      />
    </div>
  );
};
